<template>  
    <div class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
          
  
          <div class="petition-form">

             <h2>Want to learn how we can work together? Get in touch with us today.</h2>

              <!-- NAME -->
              <input name="name" type="text" v-model="name" v-validate="{ required: true}" :class="{'border-red': errors.has('name')}" placeholder="Name"> 

              <!-- EMAIL -->
              <div class="small-12 medium-12 with-input-loading">
                <input name="email" type="email" v-model="email" v-validate="{ required: true, email: true, partnershipCheckEmail: true}" :class="{'border-red': errors.has('email') || errors.has('partnershipCheckEmail')}" placeholder="Email">
                <div class="input-loading" v-if="emailCheck.checkEmailLoading">
                    <img src="https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/2903/dist/assets/img/loading-tail-spin.svg" />
                </div>
                <span class="wwf-alert">
                  <p v-if="errors.firstByRule('email', 'partnershipCheckEmail')">{{errors.first('email')}}</p>
                </span>
		          </div>

              <!-- PHONE -->
              <input name="phone" type="tel" v-model="phone" min="8" max="12" v-validate="'required'" :class="{'border-red': errors.has('phone')}" placeholder="Phone" autocomplete="tel">

              <!-- ORGANISATION -->
        			<input name="organisation" type="text" v-model="organisation" v-validate="'required'" :class="{'border-red': errors.has('organisation')}" placeholder="Organisation" autocomplete="organization">

              <!-- ENQUIRY -->
              <select name="enquiry" v-model="enquiry" v-validate="'required'" :class="{'border-red': errors.has('enquiry')}" placeholder="Enquiry type">                
                <option value="">Enquiry type</option>
                <option value="Philanthropy">Philanthropy</option>
                <option value="Business">Business</option>
                <option value="Other">Other</option>
              </select>

              <!-- MESSAGE -->
              <textarea name="message" placeholder="Message" v-model="message" maxlength="255" :class="{'border-red': errors.has('message')}"></textarea>
              <p class="word-count">{{ 255 - (message ? message.length : 0) + ' Char' }}</p>
             
             <div checked="checked" class="wwf-checkbox"><label><input type="checkbox" id="opt-in" name="opt-in" v-model="optin">
				<span class="checkbox"></span>I would like to receive news and updates from WWF-Australia</label>
		</div>
             
              <div checked="checked" class="wwf-checkbox">
                <label>
                  <input type="checkbox" id="largeProject" name="largeProject" v-model="largeProject"><span class="checkbox"></span>I would like to be contacted regarding large impact projects ($50K+)
                </label>
              </div>

 <input type="button" v-on:click="save()" value="Submit" />

            <span class="alert-box" v-show="isProfanity">No bad words! Please change your message.</span>
        </div>

      </div>
  
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import { mapState } from "vuex";

const { detect } = require('detect-browser');
const browser = detect();

export default {
  name: "my-partnershipsForm",
  props: { 
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    productIds: {
      // Attribute for the productID
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: function () {
    return {     
      name: '',      
      email: '',
      phone: '',
      organisation: '',
      enquiry: '',
      message: '',
      optin: false,
      largeProject: false,
      error: false,
      isProfanity: false,
      isShake: false,
      emailCheck: {
        timeout: null,
        lastTimestamp: Date.now(),
        checkEmailLoading: false,
        emailRegex: /.+\@.+\..+/,
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  created() {
    // CHECK EMAIL
    const partnershipCheckEmail = email => {
      if (email.length > 0 && this.emailCheck.emailRegex.test(email)) {
        return new Promise((resolve, reject) => {
          let timestamp = Date.now(); // timestamp for this api call
          this.emailCheck.lastTimestamp = timestamp; // 1 , 2 , 3
          this.emailCheck.checkEmailLoading = true;
          // Fetch Suggestions
          this.$store
            .dispatch("validateEmail", email)
            .then((response) => {
              if (response && timestamp >= this.emailCheck.lastTimestamp) {
                this.emailCheck.checkEmailLoading = false;
                resolve(response);
              }
            })
            .catch((err) => {
              console.error(err);
              this.emailCheck.checkEmailLoading = false;
              // If the call failed, do not keep the user from donating
              resolve({
                valid: true
              });
            });
        })
      } else {
        return {
          valid: false,
          data: { message: "Email invalid" }
        };
      }
    }

    Validator.extend("partnershipCheckEmail", {
      validate: partnershipCheckEmail,
      getMessage: (field, params, data) => data.message
    });
  },

  methods: {
    save: function() {

    var postBody = {
      name: this.name,
      email: this.email,      
      phone: this.phone,
      organisation: this.organisation,
      enquiry: this.enquiry,
      message: this.message ? this.message : "",
      optin: this.optin,
      largeProject: this.largeProject,
      ssoId: this.$store.getters.ssoId,
    };

    if (browser) {
      postBody.browsername = browser.name
      postBody.browserversion = browser.version
      postBody.browseros = browser.os
    }

    console.log(postBody);

      this.$validator.validate().then(result => {
        if (result) {
            this.$http
            .jsonp(
              "https://api1.webpurify.com/services/rest/?api_key=b7c6af7e5259ce74f099897deb9dcf29&method=webpurify.live.check&text=" +
                encodeURIComponent(postBody.message) +
                "&format=json"
            )
            .then(response => {
              if (response.data) {
                this.isProfanity = response.data.rsp.found != "0";
                if (!this.isProfanity) {
                  console.log("Message clean");
                  this.saveLead(postBody)
                } else {
                  console.log("Message not clean");
                }
              }
            });
        } 
        else {
          console.log("form invalid");
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: this.datalayername,
              event: "formSubmitEvent"
            });
          }
          this.isShake = true;
          setTimeout(
            function() {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    },
    saveLead: function(postBody) {
      console.log('postBody', postBody);
                    this.$store
                    .dispatch("savePartnershipForm", { lead: postBody })
                    .then((response) => {
                        console.log("form submit success");

                        if (window.dataLayer != undefined) {
                          window.dataLayer.push({
                            formName: this.datalayername,
                            event: "formSubmitSuccessEvent"
                          });
                        }

                        //Reset form
                        this.name = "";
                        this.email = "";
                        this.phone = "";
                        this.organisation = "",
                        this.enquiry = "";
                        this.message = "";
                        this.optin = false;
                        this.largeProject = false;
                    }).catch((err) => {
                        console.error("form submit failed");
                    });
                    
                    this.$store.commit("setPopupContent", {
                        title: "Thank you for your message. A team member will be in touch shortly.",
                        message: "",
                        shareButton: false,
                        recommendedReading: false,
                        component: "donate-rg-form",
                        componentparams: {
                          productIds: this.productIds,
                          emailprefill: postBody.email,
                          currentpage: true,
                          dollarhandleclick: false,
                          isDark: false
                        }
                    });
                    this.$store.commit("openPetitionPopup", true);
    }
    }
  };
</script>

<style scoped>
/* Style coming from Elcom article content */
input[type="text"],
input[type="email"],
input[type="number"],
select {
  border-color: var(--wwfGreyE4) !important;
}
input[ng-click="subscribe(subscription)"] {
  width: 100%;
  padding: 5px 15px;
}
.has-error input[type="text"],
.has-error input[type="email"],
.has-error input[type="number"],
.has-error textarea,
.has-error select {
  border: solid 2px var(--errorColor) !important;
}
</style>


// WEBPACK FOOTER //
// PartnershipsForm.vue?8f70a8ae